export const T = {
  en_GB: {
    dismissNote:
      "Closing a message hides it for everyone on this flow. It stays in Process history.",
  },
  nb_NO: {
    dismissNote:
      "Å lukke en melding skjuler den for alle på denne flyten. Den beholdes i Prosess-historikken.",
  },
} as const;
